import React, { Component } from 'react';

import { Modal, Button } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import HeaderComponent from '../../commons/header/headerComponent';
import MemberDetailsAdminView from './memberDetailsAdminView';
import PreloaderComponent from '../../commons/preloader/preloaderComponent';
import MemberNotFoundComponent from '../../commons/memberNotFound/memberNotFoundComponent';

import { getCookie } from '../../../utils/cookies';
import api from '../../../utils/api';
import apiResponseMessage from '../../../utils/apiResponse';
import FooterComponent from '../../commons/footer/footerComponent';

class MemberDetailsAdminComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            memberID: this.props.match.params.id,
            firstName: null,
            lastName: null,
            utuAccount: null,
            email: null,
            homeTown: null,
            tyyMember: null,
            privileges: null,
            entitledToCap: null,
            entitledToPatch: null,
            membershipSince: null,
            membershipUntil: null,
            createdAt: null,
            accepted: null,
            password: null,
            passwordAgain: null,
            success: null,
            message: null,
            warning: false,
            memberNotFound: false,
        };
    }

    onHandleRemove = () => {
        this.setState({ warning: true });
    };

    handleRemove = async (confirmed) => {
        // The confirmation choice arrives as an explicit boolean instead of
        // inspecting the button label (which broke under translation).
        if (confirmed) {
            const data = {
                memberID: this.state.memberID,
                email: this.state.email,
            };
            try {
                const response = await api.post('/admin/remove', data, {
                    headers: {
                        Authorization: getCookie('jasenrekisteri-token'),
                        'Content-Type': 'application/json',
                    },
                });

                this.setState({
                    ...this.state,
                    ...{
                        isLoading: false,
                        success: response.data.success,
                        message: apiResponseMessage(response.data),
                    },
                });
            } catch (e) {
                this.setState({
                    ...this.state,
                    ...{
                        success: false,
                        message:
                            apiResponseMessage(e?.response?.data, 'adminMemberDetails.removeFailed'),
                        isLoading: false,
                    },
                });
            }
        }

        this.setState({
            warning: false,
        });
    };

    render() {
        let modalClose = () => this.setState({ warning: false });
        const {
            isLoading,
            firstName,
            lastName,
            utuAccount,
            email,
            homeTown,
            tyyMember,
            privileges,
            entitledToCap,
            entitledToPatch,
            membershipSince,
            membershipUntil,
            createdAt,
            accepted,
            success,
            message,
            memberID,
            warning,
            memberNotFound,
        } = this.state;

        const { t } = this.props;

        if (isLoading) {
            return <PreloaderComponent />;
        }

        if (memberNotFound) {
            return (
                <div>
                    <HeaderComponent /> <MemberNotFoundComponent /> <FooterComponent />
                </div>
            );
        }

        return (
            <div>
                <HeaderComponent />
                <Modal
                    show={warning}
                    onHide={modalClose}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {t('adminMemberDetails.warning')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>
                            {t('adminMemberDetails.removeConfirm', {
                                name: `${firstName} ${lastName}`,
                            })}
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="success"
                            onClick={() => this.handleRemove(true)}
                        >
                            {t('memberDetails.yes')}
                        </Button>
                        <Button variant="success" onClick={modalClose}>
                            {t('memberDetails.no')}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <MemberDetailsAdminView
                    isLoading={isLoading}
                    firstName={firstName}
                    lastName={lastName}
                    utuAccount={utuAccount}
                    email={email}
                    homeTown={homeTown}
                    tyyMember={tyyMember}
                    privileges={privileges}
                    entitledToCap={entitledToCap}
                    entitledToPatch={entitledToPatch}
                    membershipSince={membershipSince}
                    membershipUntil={membershipUntil}
                    success={success}
                    message={message}
                    memberID={memberID}
                    handleRemove={this.onHandleRemove.bind(this)}
                    createdAt={createdAt}
                    accepted={accepted}
                />
                <FooterComponent />
            </div>
        );
    }
    async componentDidMount() {
        try {
            let profileData = await api.get('/member/details', {
                headers: {
                    Authorization: getCookie('jasenrekisteri-token'),
                    'Content-Type': 'application/json',
                },
                params: {
                    memberID: this.state.memberID,
                },
            });
            const capData = await api.get('/fresherpass/validate/cap', {
                headers: {
                    Authorization: getCookie('jasenrekisteri-token'),
                    'Content-Type': 'application/json',
                },
                params: {
                    memberID: this.state.memberID,
                },
            });

            const patchData = await api.get('/fresherpass/validate/patch', {
                headers: {
                    Authorization: getCookie('jasenrekisteri-token'),
                    'Content-Type': 'application/json',
                },

                params: {
                    memberID: this.state.memberID,
                },
            });

            this.setState({
                ...this.state,
                isLoading: false,
                success: true,
                entitledToCap: capData.data,
                entitledToPatch: patchData.data,
                ...profileData.data,
            });
        } catch (e) {
            this.setState({
                ...this.state,
                ...{
                    success: false,
                    message:
                        apiResponseMessage(e?.response?.data, 'memberDetails.requestFailed'),
                    isLoading: false,
                    memberNotFound: true,
                },
            });
        }
    }
}

export default withTranslation()(MemberDetailsAdminComponent);
